import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import "./sellerpiechartstyles.css";

ChartJS.register(ArcElement, Tooltip, Legend);

const SellerDoughnutChart = ({ salesReport }) => {
  const target = salesReport?.data?.target;

  const month = target?.month || "-";
  const totalTarget = target?.target_amount || 1500000;
  const achievedAmount = target?.current_month_acheived_amount || 0;
  const isTargetAchieved = achievedAmount >= totalTarget;
  const safeAchieved = isTargetAchieved
    ? totalTarget
    : achievedAmount;
  const remainingAmount = Math.max(totalTarget - achievedAmount, 0);

  const achievedPercent = Math.min(
    100,
    Math.round((achievedAmount / totalTarget) * 100)
  );

  const formatIndianAmount = (value) => {
    if (value >= 10000000) return `${(value / 10000000)}<br> Crores`;
    if (value >= 100000) return `${(value / 100000)} <br>Lakhs`;
    if (value >= 1000) return `${(value / 1000)} <br>Thousand`;
    return value.toString();
  };

  const getArcMidPosition = (startValue, arcValue, total) => {
    const CANVAS_SIZE = 350;
    const OUTER_RADIUS = CANVAS_SIZE / 2;
    const CARD_GAP = 85;
    const radius = OUTER_RADIUS + CARD_GAP;

    const startAngle =
      (startValue / total) * 2 * Math.PI - Math.PI / 2;

    const arcAngle =
      (arcValue / total) * 2 * Math.PI;

    const midAngle = startAngle + arcAngle / 2;

    return {
      left: `calc(50% + ${(radius * Math.cos(midAngle)).toFixed(2)}px)`,
      top: `calc(50% + ${(radius * Math.sin(midAngle)).toFixed(2)}px)`,
      transform: "translate(-50%, -50%)",
    };
  };
  const data = useMemo(
    () => ({
      datasets: [
        {
          data: isTargetAchieved
            ? [totalTarget]
            : [safeAchieved, remainingAmount],

          backgroundColor: isTargetAchieved
            ? ["#17C866"]
            : ["#17C866", "#78BCFF"],

          borderWidth: 0,
          borderRadius: isTargetAchieved ? 0 : 14,

          hoverOffset: 0,
        },
      ],
    }),
    [safeAchieved, remainingAmount, isTargetAchieved, totalTarget]
  );

  const options = {
    cutout: "70%",
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 0 },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <div className="bg-white" style={{ padding: "0px 30px 30px" }}>
      <div className="flex justify-between mb-8">
        <div>
          <h3 className="font-semibold text-gray-900 monthly-sale">
            Monthly Sale Goal
          </h3>
          <p className="text-gray-500 target-progress-p">
            {month} Target Progress
          </p>
        </div>
        <div className="text-right">
          <p className="text-2xl font-bold archeived-percentage-doughnut">
            {achievedPercent}%
          </p>
          <p className="Acheived-progress-p text-gray-500">
            Achieved
          </p>
        </div>
      </div>
      <div className="relative flex justify-center chart-hover-group">
        <div className="doughnut-div">
          <Doughnut data={data} options={options} />
        </div>

        {/* Center Text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <p
            className="font-bold total-target-amount text-center"
            dangerouslySetInnerHTML={{
              __html: formatIndianAmount(totalTarget),
            }}
          />
          <p className="text-gray-500 center-total-target">
            Total Target
          </p>
        </div>


        {/* Achieved Card */}
        <div
          className="absolute hover-card card archeived-card"
          style={getArcMidPosition(0, safeAchieved, totalTarget)}
        >
          <p className="text-gray-700" style={{ fontSize: "18px" }}>
            Achieved
          </p>
          <p className="font-semibold" style={{ fontSize: "16px" }}>
            ₹{achievedAmount.toLocaleString("en-IN")}
          </p>
        </div>

        {/* Remaining Card – ALWAYS SHOWN */}
        <div
          className="absolute hover-card card remaining-card"
          style={getArcMidPosition(
            safeAchieved,
            totalTarget - safeAchieved,
            totalTarget
          )}
        >
          <p className="text-gray-700" style={{ fontSize: "18px" }}>
            Remaining
          </p>
          <p className="font-semibold" style={{ fontSize: "18px" }}>
            ₹{remainingAmount.toLocaleString("en-IN")}
          </p>
        </div>
      </div>

      <div className="flex marked-color-archieved justify-between">
        <div className="acheived-dot text-center">
          <p className="acheived-dot-p">Achieved</p>

        </div>
        <div className="remaining-dot">
          <p className="remaining-dot-p"> Remaining</p>

        </div>
      </div>

      {/* Footer */}
      <p className="text-center text-[#089848] text-sm font-medium keep-going">
        {isTargetAchieved ? (
          <>🎉 Congratulations! You have successfully achieved your target.</>
        ) : (
          <>
            Keep going! You need<strong> ₹{remainingAmount.toLocaleString("en-IN")}</strong> more
            to reach your goal
          </>
        )}
      </p>

    </div>
  );
};

export default SellerDoughnutChart;

